import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { findLastIndex } from 'lodash';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '15px 0'
  },
  number: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#002380'
  },
  impressionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',

    '& p': {
      color: '#A7AAAE',
      fontSize: 12
    }
  },
  impression: {
    fontSize: 16,
    fontWeight: 'bold'
  }
}));

const ImpressionComponent = ({ number, impression, numOfInvestors }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <h3 className={classes.number}>{number}</h3>
      <div className={classes.impressionContainer}>
        <h4 className={classes.impression}>{impression}</h4>
        <p>{numOfInvestors} investors</p>
      </div>
    </div>
  );
};

export default ImpressionComponent;
